/**
 * rugier-mega-menu.js
 * Mega Menu Rugier â€“ thĂ¨me Dawn
 */

(function () {
  'use strict';

  const megaMenu = document.getElementById('rugier-mega-menu');
  if (!megaMenu) return;

  // Injection dans sticky-header
  const stickyHeader = document.querySelector('sticky-header');
  if (stickyHeader && !stickyHeader.contains(megaMenu)) {
    stickyHeader.appendChild(megaMenu);
  }

  // Colonnes : 1 ligne toujours, min 2, max 8
  megaMenu.querySelectorAll('.rugier-mega-menu__panel').forEach((panel) => {
    const count = panel.querySelectorAll('.rugier-mega-menu__card').length;
    const cols = Math.min(Math.max(count, 2), 8);
    panel.querySelector('.rugier-mega-menu__grid')
      ?.style.setProperty('--mega-cols', cols);
  });

  // Helpers
  function slugify(text) {
    return text.trim().toLowerCase().replace(/'/g, '').replace(/\s+/g, '-');
  }

  function getNavItemText(el) {
    const span = el.querySelector('span:not(.icon-wrapper):not(.svg-wrapper)');
    return (span ? span.textContent : el.textContent).trim();
  }

  // Nav items
  const navItems = document.querySelectorAll(
    'nav.header__inline-menu .header__menu-item'
  );

  let closeTimer = null;

  function openPanel(groupKey) {
    clearTimeout(closeTimer);
    megaMenu.querySelectorAll('.rugier-mega-menu__panel').forEach((p) => {
      p.classList.remove('is-active');
      p.setAttribute('aria-hidden', 'true');
    });
    const panel = megaMenu.querySelector(
      `.rugier-mega-menu__panel[data-group="${groupKey}"]`
    );
    if (!panel) return;
    panel.classList.add('is-active');
    panel.setAttribute('aria-hidden', 'false');
    megaMenu.classList.add('is-open');
    megaMenu.setAttribute('aria-hidden', 'false');
  }

  function scheduleClose() {
    closeTimer = setTimeout(() => {
      megaMenu.querySelectorAll('.rugier-mega-menu__panel').forEach((p) => {
        p.classList.remove('is-active');
        p.setAttribute('aria-hidden', 'true');
      });
      megaMenu.classList.remove('is-open');
      megaMenu.setAttribute('aria-hidden', 'true');
    }, 160);
  }

  navItems.forEach((item) => {
    const text = getNavItemText(item);
    const groupKey = slugify(text);
    const hasPanel = megaMenu.querySelector(
      `.rugier-mega-menu__panel[data-group="${groupKey}"]`
    );
    const li = item.closest('li');
    if (!li) return;

    if (hasPanel) {
      li.classList.add('has-mega-menu');
      li.addEventListener('mouseenter', () => openPanel(groupKey));
      li.addEventListener('mouseleave', scheduleClose);
    } else {
      li.addEventListener('mouseenter', () => scheduleClose());
    }
  });

  megaMenu.addEventListener('mouseenter', () => clearTimeout(closeTimer));
  megaMenu.addEventListener('mouseleave', scheduleClose);

  document.addEventListener('click', (e) => {
    if (
      !megaMenu.contains(e.target) &&
      !e.target.closest('nav.header__inline-menu')
    ) {
      clearTimeout(closeTimer);
      megaMenu.classList.remove('is-open');
      megaMenu.setAttribute('aria-hidden', 'true');
    }
  });

})();